<template>
  <div class="row">
    <div class="col-xs-12 col-md-6">
      <text-box data-cy="config-form-synergid-ean" :label="$t('synergrid.config.ean')" :rules="{ 'ean-code-validator': true, required: true }" placeholder='541447856985698523' v-model='value.ean'></text-box>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Inject, Watch } from 'vue-property-decorator'
import { idGenerator, helper } from '@/services'
import { RemoveRequestInfo } from '@/models'

@Component({
  name: 'synergrid-remove-request-form',
  components: {
  }
})
export default class SynergridRemoveRequestForm extends Vue {

  //#region [Property]
  @Prop({ type: Object, required: true })
  public readonly value!: RemoveRequestInfo
  //#endregion

  //#region [Data]
  public fieldId: string = idGenerator.getId()
  //#endregion
}
</script>